import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { Box, Button, Tooltip } from '@mui/material';
import { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';
import { gameConfigStore } from '../../store/GameConfigStore';
import { useAppDispatch } from '../../store/Hooks';
import { QuestionSetConfig } from '../../types/GameplayTypes';

type Props = {
	questionSet: QuestionSetConfig;
	hasUnsavedChanges: boolean;
};

export const PlayButton: FunctionComponent<Props> = (props) => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	function openGameSetup() {
		dispatch(gameConfigStore.actions.setQuestionSet(props.questionSet));
		void navigate('/setup');
	}

	const tooltip = props.hasUnsavedChanges
		? 'Save changes to play this Question Set'
		: 'Play the game with this Question Set';

	return <Tooltip title={tooltip}>
		<Box> {/* Box to allow tooltip to get hover events when button disabled */}
			<Button variant="outlined" startIcon={<PlayArrowIcon />}
				onClick={openGameSetup}
				disabled={props.hasUnsavedChanges}>
				Play
			</Button>
		</Box>
	</Tooltip>;
};
